import React, { FC, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { PageQueries, replaceQuery } from '@specs/navigation';
import { toy } from '@specs/specs';
import { Confetti } from '@components/UIKit/Confetti/Confetti';
const Modal = dynamic(import('@components/Modals/Modal').then(module => module.Modal), {
  ssr: false
});
const ToyCollected = dynamic(import('@components/Modals/Variants/ToyCollected/ToyCollected').then(module => module.ToyCollected), {
  ssr: false
});
interface Props {
  toyName: toy['name'];
}
export const Modals: FC<Props> = ({
  toyName
}) => {
  const router = useRouter();
  const {
    collectToyStatus
  }: PageQueries = router.query;
  const [isOpenModal, setIsOpenModal] = useState(false);
  useEffect(() => {
    if (!collectToyStatus) return;
    setIsOpenModal(collectToyStatus === 'success');
  }, [collectToyStatus]);
  const closeHandler = () => {
    setIsOpenModal(false);
  };
  return <>
            <Modal isOpen={isOpenModal} onClose={closeHandler} onAfterClose={() => {
      replaceQuery(router, {
        collectToyStatus: undefined
      });
    }} data-sentry-element="Modal" data-sentry-source-file="Modals.tsx">
                <ToyCollected closeHandler={closeHandler} toyName={toyName} data-sentry-element="ToyCollected" data-sentry-source-file="Modals.tsx" />
            </Modal>
            {isOpenModal && collectToyStatus === 'success' && <Confetti />}
        </>;
};